const longitude = [
    { type: 'required', message: 'Longitude is required' },
    { type: 'maxlength', message: 'Longitude must be 13 characters long' },
    { type: 'minlength', message: 'Longitude must be 13 characters long' },
    { type: 'pattern', message: 'Your latitude must be of this format: 25.3007394343' }
]

export default { longitude };